import T from 'prop-types';
import React from 'react';
import { Column, Grid } from '@acast/decibel';
import PositionField from '../fields/position';
import AdMarkerPositionRecommendations from '../fields/ad-marker-position-recommendations';
import { markerPropType } from '../../../../../../customPropTypes';

export default function AdMarkerSettings({
  marker,
  markers,
  episodeDuration,
  onUpdateMarker,
  silenceDetected,
}) {
  const { placement } = marker.body;

  const maybeRenderAdMarkerPositionRecommendations = () => {
    if (placement !== 'midroll') {
      return null;
    }

    return (
      <Column>
        <AdMarkerPositionRecommendations
          marker={marker}
          markers={markers}
          episodeDuration={episodeDuration}
          silenceDetected={silenceDetected}
          onChange={onUpdateMarker('start')}
        />
      </Column>
    );
  };

  return (
    <Grid>
      {maybeRenderAdMarkerPositionRecommendations()}
      <Column>
        <PositionField
          marker={marker}
          markers={markers}
          episodeDuration={episodeDuration}
          onChange={onUpdateMarker('start')}
        />
      </Column>
    </Grid>
  );
}

AdMarkerSettings.propTypes = {
  episodeDuration: T.number,
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType),
  onUpdateMarker: T.func.isRequired,
  silenceDetected: T.arrayOf(
    T.shape({
      duration: T.number,
      end: T.number,
    })
  ),
};
